import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLazyQuery } from '@apollo/client';

import WDT_ACTIVE_STUDENT_REPORT_QUERY from 'graph/reports/wdt-active-students-report-query';
import RadialChartCard from '../../../../charts/RadialChartCard';
import useReportQueryParams from '../../../../hooks/use-report-query-params';
import { ChartCardType } from '../../../../types';
import { getQueryVariables } from '../../../../utils/report-param-utils';

const ActiveStudentsChart: React.FC = () => {
  const { t } = useTranslation(['Reports', 'ReportsHelpCharts']);
  const [{ dateRange, entityType, entityId }] = useReportQueryParams();
  const [fetchReport, { data, loading }] = useLazyQuery(WDT_ACTIVE_STUDENT_REPORT_QUERY);

  const { activeStudentCount, totalStudentCount } = data?.wdtActiveStudentsReport || {};

  useEffect(() => {
    fetchReport({ variables: getQueryVariables({ entityId, entityType, dateRange }) });
  }, [fetchReport, entityId, entityType, dateRange]);

  return (
    <RadialChartCard
      type={ChartCardType.COUNT}
      total={totalStudentCount}
      progress={activeStudentCount}
      title={t('Active Students')}
      helpText={t('wdttotalAndActiveStudents', { ns: 'ReportsHelpCharts' })}
      color="#006db8"
      loading={loading}
    />
  );
};

export default React.memo(ActiveStudentsChart);
